import {useEffect, useMemo, useRef, useState} from 'react'
import {
  SActionBtn,
  SLowcodeList,
  STableActions,
} from 'shj-components'

import {config} from './config'
import CheckThePhone from "@/components/CheckThePhone";
import UrlConfig from "@/api/UrlConfigs.ts";
import {AddOrEditDrawer} from "@/pages/crm/customerManage/components/addOrEdit.tsx";
import {useSetState} from "ahooks";
import {useNavigate} from "react-router-dom";
import {getNicheListByPage} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {filterSerchData} from "@/utils/common.ts";
import {Select} from "antd";

export default function NicheList() {
  const navigate = useNavigate();
  const listRef = useRef()
  const [state, setState] = useSetState({
    open: false,
  })

  const fetchList = ({current, pageSize, query}) => {
    return new Promise( (resolve, reject) => {
      const newObj = {...filterSerchData({...query}, ['lastFollowTime'])};
      getNicheListByPage({params: {pageId: current, pageSize}, data: {...newObj}}).then((res: any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onAdd = () => {setState({open: true})}

  const onDetail = ({ id, customerId, statusName }) => {
    navigate('/customerManage/nicheList/detail/' + id + '/' + customerId, { state: { statusName } })
  }

  const extensions = {
    request: {fetchList},
    events: {onAdd},
    customRender: {
      checkPhone(text: any, re: any) {
        return <CheckThePhone initValue={text} url={`${UrlConfig.PlusCrmWeb.TrackPlanViewPhone}/${re?.id}`}
                              auth="insureInfoIdCard"
                              showValue={'idCard'}
                              type="GET"/>
      },
      actionRender(_, record: Record<string, any>) {
        return (
            <STableActions>
              <SActionBtn onClick={() => onDetail(record)}>详情</SActionBtn>
            </STableActions>
        )
      },
    },
  }
  return (
      <div>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        <AddOrEditDrawer open={state.open} onClose={() => setState({open: false})} fn={listRef.current?.reload}/>
      </div>
  )
}
